import podcastImg from '@epi-assets/images/Edenred-EMP-banner-Etumatkalla-podcast.jpg';
import rewardingImg from '@epi-assets/images/Edenred-EMP-banner-Rewarding-guide.jpg';
import bestLunchImg from '@epi-assets/images/Edenred-EMP-banner-best_lunch_2025.png';
import lunchImg from '@epi-assets/images/Edenred-EMP-banner-lunch.jpg';
import paymentImg from '@epi-assets/images/Edenred-EMP-banner-payment.jpg';
import summerGiftDealImg from '@epi-assets/images/Edenred-EMP-banner-summer-deal.jpg';
import delicardCampaignImg from '@epi-assets/images/Edenred-EMP-banner-delicard-campaign.png';
import bestLunchCampaignImg from '@epi-assets/images/Edenred-EMP-banner-bestlunch-campaign.png';

interface BannerContent {
  locale: 'en' | 'fi';
  header: string;
  imageAlt: string;
  imageSrc: string;
  link: string;
  linkKind: 'Relative';
  linkText: string;
  text: string;
  linkTwo?: string;
  linkTextTwo?: string;
  sameTab?: boolean;
  sameTabTwo?: boolean;
}

interface Banner {
  content: BannerContent;
  id: number;
  name: string;
  priority: number;
  templateName: 'Banner';
  startDate?: Date;
  endDate?: Date;
}

export const homeBanner = (
  paymentLimitsImg: string,
  delicardImg: string,
  taxationImg: string
): Banner[] => [
  {
    content: {
      locale: 'en',
      header: 'Plan ahead and save on your corporate Christmas gifts',
      imageAlt: 'Delicard gift cards for Christmas',
      imageSrc: delicardCampaignImg,
      link: 'https://delicard.edenred.fi/en/buy-gift-cards?utm_source=emp&utm_medium=referral&utm_campaign=DC_early-bird&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Buy now',
      text: 'Order Delicard gift cards for Christmas now at a 15 % discount. The special offer is valid until 16.9.'
    },
    id: 19,
    name: 'Delicard®',
    priority: 1,
    templateName: 'Banner',
    startDate: new Date('2026-08-26'),
    endDate: new Date('2026-09-17')
  },
  {
    content: {
      locale: 'fi',
      header: 'Fiksu ostaa yrityslahjat nyt ja saa parhaan säästön',
      imageAlt: 'Delicard gift cards for Christmas',
      imageSrc: delicardCampaignImg,
      link: 'https://www.delicard.fi/osta-lahjakortteja?utm_source=emp&utm_medium=referral&utm_campaign=DC_early-bird&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Osta nyt',
      text: 'Hyödynnä kampanjaetu ja tilaa Delicard-lahjakortit jouluun -15 % alennuksella. Etu voimassa 16.9. asti.'
    },
    id: 20,
    name: 'Delicard Campaign Banner',
    priority: 1,
    templateName: 'Banner',
    startDate: new Date('2026-08-26'),
    endDate: new Date('2026-09-17')
  },
  {
    content: {
      locale: 'en',
      header: 'Vote for Finland’s best lunch of 2026',
      imageAlt: 'Best lunch campaign',
      imageSrc: bestLunchCampaignImg,
      link: 'https://paraslounas.edenred.fi/fi/aanesta?utm_source=emp&utm_medium=referral&utm_campaign=spl2026&utm_content=carousel',
      linkTwo:
        'https://edenred.fi/en/employer/lunch-benefit?utm_source=emp&utm_medium=referral&utm_campaign=spl2026&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Vote and win',
      linkTextTwo: 'Explore lunch benefit',
      text: 'Where can Finland’s best lunch spot be found? Vote for your favorite and you could win a 500€ gift card for your dream restaurant, along with other delicious prizes. If the lunch benefit is not yet in your use, now is a great time to explore it.'
    },
    id: 21,
    name: 'Vouchers',
    priority: 2,
    templateName: 'Banner',
    startDate: new Date('2026-08-31'),
    endDate: new Date('2026-09-21')
  },
  {
    content: {
      locale: 'fi',
      header: 'Äänestä vuoden 2026 parasta lounaspaikkaa',
      imageAlt: 'Best lunch campaign',
      imageSrc: bestLunchCampaignImg,
      link: 'https://paraslounas.edenred.fi/fi/aanesta?utm_source=emp&utm_medium=referral&utm_campaign=spl2026&utm_content=carousel',
      linkTwo:
        'https://edenred.fi/fi/tyonantaja/lounasetu?utm_source=emp&utm_medium=referral&utm_campaign=spl2026&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Äänestä ja voita',
      linkTextTwo: 'Tutustu lounasetuun',
      text: 'Mistä löytyy Suomen paras lounaspaikka? Äänestä suosikkiasi ja voit voittaa 500 € lahjakortin unelmiesi ravintolaelämykseen sekä muita herkullisia palkintoja. Jos lounasetu ei ole vielä käytössänne, nyt on erinomainen hetki tutustua sen hyötyihin.'
    },
    id: 22,
    name: 'Best lunch campaign',
    priority: 2,
    templateName: 'Banner',
    startDate: new Date('2026-08-31'),
    endDate: new Date('2026-09-21')
  },
  {
    content: {
      locale: 'en',
      header: 'A burning hot summer gift deal',
      imageAlt: 'Summer gift deal',
      imageSrc: summerGiftDealImg,
      link: 'https://delicard.edenred.fi/en/buy-gift-cards/unlimited-bonus?utm_source=emp&utm_medium=referral&ut%E2%80%A6',
      linkKind: 'Relative',
      linkText: 'To the offer',
      text: 'Delicard Unlimited gift cards are available for a limited time in summer designs and with a 10% discount! Offer is valid only until 18.6.2026.'
    },
    id: 13,
    name: 'Delicard®',
    priority: 3,
    templateName: 'Banner',
    startDate: new Date('2026-06-01'),
    endDate: new Date('2026-06-19')
  },
  {
    content: {
      locale: 'fi',
      header: 'Polttavan hyvä kesälahjadiili',
      imageAlt: 'Delicard gift cards with a gift box in the background',
      imageSrc: summerGiftDealImg,
      link: 'https://delicard.edenred.fi/osta-lahjakortteja/unlimited-bonus?utm_source=emp&utm_medium=referral&u%E2%80%A6',
      linkKind: 'Relative',
      linkText: 'Hyödynnä tarjous',
      text: 'Delicard Unlimited -lahjakortit löytyvät rajoitetun ajan kesäisissä kuoseissa ja 10 % alennuksella! Tarjous on voimassa vain 18.6. asti.'
    },
    id: 13,
    name: 'Summer gift deal',
    priority: 3,
    templateName: 'Banner',
    startDate: new Date('2026-06-01'),
    endDate: new Date('2026-06-19')
  },
  {
    content: {
      locale: 'en',
      header: 'Lunch benefit in 2026',
      imageAlt: 'A person eating lunch',
      imageSrc: lunchImg,
      link: '/en/manage-benefits',
      sameTab: true,
      linkKind: 'Relative',
      linkText: 'Lounari settings',
      text: 'The new lunch benefit values (8.80€ - 14.00€) are valid and can be updated to Lounari settings from 1.1.2026. If the lunch benefit is loaded with the Maximum benefit value option, it will update automatically without any action required.'
    },
    id: 15,
    name: 'Lunch values',
    priority: 4,
    templateName: 'Banner',
    startDate: new Date('2025-12-12'),
    endDate: new Date('2026-02-01')
  },
  {
    content: {
      locale: 'fi',
      header: 'Lounasetu vuonna 2026',
      imageAlt: 'A person eating lunch',
      imageSrc: lunchImg,
      link: '/manage-benefits',
      sameTab: true,
      linkKind: 'Relative',
      linkText: 'Lounarin asetukset',
      text: 'Lounasedun uudet arvot (8,80 € - 14,00 €) ovat voimassa ja päivitettävissä Lounarin asetuksiin 1.1.2026 alkaen. Mikäli lounasetu on ladattu Edun maksimiarvo -valinnalla, se päivittyy automaattisesti ilman toimenpiteitä. '
    },
    id: 16,
    name: 'Lunch values',
    priority: 4,
    templateName: 'Banner',
    startDate: new Date('2025-12-12'),
    endDate: new Date('2026-02-01')
  },
  {
    content: {
      locale: 'fi',
      header: 'Suomen paras lounas 2025',
      imageAlt: 'Best lunch logo',
      imageSrc: bestLunchImg,
      link: 'https://paraslounas.edenred.fi/fi/aanesta?utm_source=emp&utm_medium=referral&utm_campaign=spl2025&utm_content=banner',
      linkKind: 'Relative',
      linkText: 'Äänestä nyt',
      text: 'Edenred etsii jälleen Suomen parasta lounasta. Kannusta henkilöstöäsi äänestämään lempilounastaan nyt! Äänestäneiden kesken arvotaan lounasrahaa sekä lahjakortteja mm. Kotipizzaan ja Espresso Houseen.'
    },
    id: 2,
    name: 'Best Lunch 2025',
    priority: 7,
    templateName: 'Banner',
    startDate: new Date('2025-09-01'),
    endDate: new Date('2025-09-22')
  },
  {
    content: {
      locale: 'en',
      header: 'Employee benefit payment limits',
      imageAlt: 'Young woman eating lunch in a restaurant',
      imageSrc: paymentLimitsImg,
      link: 'https://edenred.fi/en/blog/employee-benefit-payment-limits',
      linkKind: 'Relative',
      linkText: 'Check the payment limits',
      text: "What were the tax-free payment limits this year? You'll find them by clicking the link!"
    },
    id: 3,
    name: 'Payment Limits',
    priority: 5,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Työsuhde-etujen ajankohtaiset maksurajat',
      imageAlt: 'Young woman eating lunch in a restaurant',
      imageSrc: paymentLimitsImg,
      link: 'https://edenred.fi/fi/blog/tyosuhde-etujen-maksurajat',
      linkKind: 'Relative',
      linkText: 'Tarkista maksurajat',
      text: 'Mitä olivatkaan verovapaat maksurajat tänä vuonna? Löydät ne linkin takaa!'
    },
    id: 4,
    name: 'Payment Limits',
    priority: 5,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Paper vouchers valid until 31.12.2026',
      imageAlt: 'A person eating lunch',
      imageSrc: paymentImg,
      link: 'https://edenred.fi/en/vouchers-to-digital-benefits',
      linkTwo: 'https://edenred.fi/en/vouchers-to-digital-benefits#contact-us',
      linkKind: 'Relative',
      linkText: 'Read more',
      linkTextTwo: 'Contact us',
      text: 'The sale of Lunch and Virike vouchers will end on 31.5.2026. All vouchers order payments must be completed by 11.6.2026 to accept the orders. Payments received after this date will be refunded. The vouchers will remain as a payment method until 31.12.2026. Be sure to inform your employees accordingly.'
    },
    id: 17,
    name: 'Vouchers',
    priority: 6,
    templateName: 'Banner',
    startDate: new Date('2025-12-12'),
    endDate: new Date('2026-12-31')
  },
  {
    content: {
      locale: 'fi',
      header: 'Paperiset setelit voimassa 31.12.2026 asti',
      imageAlt: 'A person eating lunch',
      imageSrc: paymentImg,
      link: 'https://edenred.fi/fi/seteleista-digitaalisiin-tyosuhde-etuihin',
      linkTwo:
        'https://edenred.fi/fi/seteleista-digitaalisiin-tyosuhde-etuihin#ota-yhteytta',
      linkKind: 'Relative',
      linkText: 'Lue lisää',
      linkTextTwo: 'Ota yhteyttä',
      text: 'Lounas- ja Virikeseteleiden myynti päättyy 31.5.2026. Kaikkien setelitilausten maksujen on oltava suoritettuna viimeistään 11.6.2026, jotta tilaukset voidaan hyväksyä. Tämän jälkeen vastaanotetut maksut palautetaan. Setelit toimivat maksutapana 31.12.2026 asti. Muista tiedottaa asiasta myös työntekijöillesi.'
    },
    id: 18,
    name: 'Vouchers',
    priority: 6,
    templateName: 'Banner',
    startDate: new Date('2025-12-12'),
    endDate: new Date('2026-12-31')
  },
  {
    content: {
      locale: 'en',
      header: "Finland's Best Lunch 2025",
      imageAlt: 'Best lunch logo',
      imageSrc: bestLunchImg,
      link: 'https://paraslounas.edenred.fi/fi/aanesta?utm_source=emp&utm_medium=referral&utm_campaign=spl2025&utm_content=banner',
      linkKind: 'Relative',
      linkText: 'Vote now',
      text: 'Edenred is looking for the best lunch in Finland. Encourage your employees to vote for their favorite lunch spot now! Voting is easy, and among voters we will raffle lunch money, gift cards to Kotipizza and Espresso House and more!'
    },
    id: 1,
    name: 'Payment Limits',
    priority: 7,
    templateName: 'Banner',
    startDate: new Date('2025-09-01'),
    endDate: new Date('2025-09-22')
  },
  {
    content: {
      locale: 'en',
      header: "Edenred's podcast: Etumatkalla",
      imageAlt: 'Podcast host posing for camera',
      imageSrc: podcastImg,
      link: 'https://edenred.fi/etumatkalla-podcast?utm_source=employer-portal&utm_medium=referral&utm_campaign=etumatkalla-podcast&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Explore (in Finnish)',
      text: `Are you looking for a Finnish podcast on HR topics that provides practical tips for people interested in workplace well-being? Edenred's Etumatkalla podcast is made for a better working life!`
    },
    id: 5,
    name: 'Podcast',
    priority: 9,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Edenredin Etumatkalla-podcast',
      imageAlt: 'Podcast host posing for camera',
      imageSrc: podcastImg,
      link: 'https://edenred.fi/etumatkalla-podcast?utm_source=employer-portal&utm_medium=referral&utm_campaign=etumatkalla-podcast&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Tutustu ja kuuntele',
      text: 'Oletko etsinyt suomenkielistä HR-aiheista podcastia, jossa annetaan käytännönläheisiä vinkkejä työhyvinvoinnista kiinnostuneille? Edenredin Etumatkalla-podcast on tehty parempaa työelämää varten!'
    },
    id: 6,
    name: 'Podcast',
    priority: 9,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Want to learn more about benefit taxation? ',
      imageAlt: 'Cover of the Edenred tax guide',
      imageSrc: taxationImg,
      link: 'https://edenred.fi/en/download-tax-guide?utm_source=employer-portal&utm_medium=referral&utm_campaign=tax-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Download tax guide',
      text: 'Clarify employee benefit taxation by downloading our comprehensive and highly popular tax guide.'
    },
    id: 7,
    name: 'Tax guide',
    priority: 10,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Haluatko oppia lisää etujen verotuksesta?',
      imageAlt: 'Cover of the Edenred tax guide',
      imageSrc: taxationImg,
      link: 'https://edenred.fi/fi/lataa-verotusopas?utm_source=employer-portal&utm_medium=referral&utm_campaign=tax-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Lataa verotusopas',
      text: 'Selvennä työsuhde-etujen verotuksen kiemuroita lataamalla kattava ja suuren  suosion  saanut vero-oppaamme.'
    },
    id: 8,
    name: 'Tax guide',
    priority: 10,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Are you looking for tips on tax-free rewarding?',
      imageAlt: 'Cover of the Edenred rewarding guide',
      imageSrc: rewardingImg,
      link: 'https://edenred.fi/en/delicard-abcs-of-rewarding?utm_source=employer-portal&utm_medium=referral&utm_campaign=rewarding-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Download rewarding guide',
      text: 'Rewarding employees fosters commitment to the workplace, increases motivation, and improves the employee experience. Do you know how to reward employees tax-free in various situations? Download our guide to find out!'
    },
    id: 9,
    name: 'Rewarding guide',
    priority: 11,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Kaipaatko vinkkejä verovapaaseen palkitsemiseen?',
      imageAlt: 'Cover of the Edenred rewarding guide',
      imageSrc: rewardingImg,
      link: 'https://edenred.fi/fi/delicard-palkitsemisen-abc?utm_source=employer-portal&utm_medium=referral&utm_campaign=rewarding-guide&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Lataa palkitsemisen opas',
      text: 'Työntekijöiden palkitseminen sitouttaa työpaikkaan, lisää motivaatiota, ja parantaa työntekijäkokemusta. Tiedätkö, miten voit palkita henkilöstöä erilaisissa tilanteissa verovapaasti? Lataa oppaamme niin se selviää!'
    },
    id: 10,
    name: 'Rewarding guide',
    priority: 11,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'en',
      header: 'Tax-free recognition on special occasions',
      imageAlt: 'Delicard gift cards with a gift box in the background',
      imageSrc: delicardImg,
      link: 'https://www.delicard.fi/en/buy-gift-cards?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkTwo:
        'https://www.delicard.fi/en/request-offer?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Order gift cards',
      linkTextTwo: 'Request an offer',
      text: 'Christmas gifts, retirement, anniversaries and birthdays, summer gifts... Delicard® gift cards offer a tax-free option for expressing gratitude and congratulations for every celebration!'
    },
    id: 11,
    name: 'Delicard®',
    priority: 12,
    templateName: 'Banner'
  },
  {
    content: {
      locale: 'fi',
      header: 'Verovapaata muistamista merkkipäivinä',
      imageAlt: 'Delicard gift cards with a gift box in the background',
      imageSrc: delicardImg,
      link: 'https://www.delicard.fi/?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkTwo:
        'https://www.delicard.fi/pyyda-tarjous?utm_source=employer-portal&utm_medium=referral&utm_campaign=dc_campaign&utm_content=carousel',
      linkKind: 'Relative',
      linkText: 'Osta lahjakortteja',
      linkTextTwo: 'Kysy tarjous',
      text: 'Joululahja, eläkkeelle siirtyminen, merkki- ja syntymäpäivät, kesälahja... Delicard®-lahjakortit tarjoavat verovapaan vaihtoehdon kiitoksen osoittamiseen ja onnitteluun jokaisessa juhlan aiheessa!'
    },
    id: 12,
    name: 'Delicard®',
    priority: 12,
    templateName: 'Banner'
  }
];
